import {connect} from "react-redux"
import {IncomingHttpHeaders} from "http"
import {REALM_HEADER} from "@next/utils"
import urls from "../../config/urls"
import State from "../../ducks/state"

export const mapStateToProps = (state: State) => {
    const {
        request: {siteUrl, headers},
        favourites: {enableFavourites, hasFavourites},
        text: {
            favourites: {
                altText,
                burgerMenu: {title, description},
            },
        },
        settings: {iconsVersionPath},
    } = state
    const realm = (headers as IncomingHttpHeaders)[REALM_HEADER] as string
    const iconSrc = urls.burgerMenu.favourites(realm, false, iconsVersionPath)

    return {
        altText,
        smallIconUrl: iconSrc,
        enableFavourites,
        hasFavourites,
        favouritesUrl: `${siteUrl}${urls.favourites.url}`,
        title,
        description,
    }
}

export default connect(mapStateToProps)
